'use strict';
//***********************************************************************************
//***********************************************************************************
import { cn_svg_tool_creation } from './cn_svg_tool_creation';
import { cn_svg_map } from './cn_svg_map';
import { cn_polygon_handler } from './cn_polygon_handler';
import { cn_mouse_event } from './cn_mouse_event';
import { cn_element } from '../model/cn_element';
import { cn_edition_handler } from './cn_edition_handler';
import { HELPER } from '../utils/cn_wordings';
import { cn_parking_space } from '../model/cn_parking_space';
import { cn_parking_space_handler } from './cn_parking_space_handler';

/**
 * @class cn_svg_tool_parking_space_creation
 * A tool to create parking_space and columns
 *
 * Available events :
 * - "beam_height_clicked(v)" : called when one beam height is clicked. Argument is height in meters. Expect a call to set_beam_height
 * - "column_height_clicked(v)" : called when column height is clicked. Argument is height in meters. Expect a call to set_column_height
 */
export class cn_svg_tool_parking_space_creation extends cn_svg_tool_creation {
    //*****************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} map
     */
    constructor(map) {
        super(map);

        this._creation_handler = null;
        this._initiate_creation();
        this.element_filter = (element) => {
            return element.constructor == cn_parking_space;
        };
        this._ghost = null;
    }

    //*****************************************************************
    //*** Parameters
    //*****************************************************************

    //*****************************************************************
    //*** Must return 'true' if wa are in modal creation.
    //*****************************************************************
    is_creating() {
        return this._creation_handler.is_creating();
    }

    open_tool() {
        super.open_tool();
        this._initiate_creation();
        this.push_instruction_input(HELPER.parking_space.creation);
    }

    //***********************************************************************************
    //**** Refresh
    //***********************************************************************************
    draw(camera) {
        this._creation_handler.visible = (this._focus_handler == this._creation_handler);
        let html = "";
        if (this._ghost) html += this._ghost.draw(camera);
        html += super.draw(camera);
        return html;
    }

    //***********************************************************************************
    //**** Start creation of stairs
    //***********************************************************************************
    _initiate_creation() {
        if (this._creation_handler) {
            const index = this._handlers.indexOf(this._creation_handler);
            if (index >= 0) this._handlers.splice(index, 1);
        }
        var obj = this;
        var scene = obj._scene;
        const handler = cn_polygon_handler.create_open_polygon(this, 0, true, true);
        handler.snap_elements = scene.spaces.concat(scene.parking_spaces);
        handler.display_measures = false;
        this._creation_handler = handler;
        this._handlers.unshift(handler);
        this._ghost = null;

        handler.on('start_creation', () => {
            obj._terminate_edition();
        });

        handler.on('end_creation', () => {

            obj.push_transaction('Création de places de parking');
            obj.push_item_set(scene, 'parking_spaces');

            const new_parking_space = new cn_parking_space(scene);
            new_parking_space.vertices = handler.vertices;
            scene.parking_spaces.push(new_parking_space);
            obj.call('creation', [new_parking_space]);
            obj._initiate_creation();

            //*** Edit recently created slab opening */
            obj._initiate_edition([new_parking_space]);
        });

        handler.check_change = function () {
            if (handler.vertices.length < 2) return true;
            obj._ghost = new cn_parking_space(scene);
            obj._ghost.vertices = handler.vertices;
            return true;
        }
    }

    //***********************************************************************************
    //**** Edition elements
    //***********************************************************************************
    /**
     * TODO : derivate in order to allow edition of other element in the process of creation
     * @param {cn_mouse_event} mouse_event
     * @returns {cn_element}
     */
    _find_other_element(mouse_event) {
        return this._scene.find_parking_space(mouse_event.mouse_world);
    }

    /**
     * TODO : derivate in order to provide an edition handler
     * @param {Array<cn_parking_space>} elements
     * @returns {cn_edition_handler}
     */
    _build_edition_handler(elements) {
        return new cn_parking_space_handler(elements, this._map, true);
    }

    /**
     * TODO : derivate in order to find siblings of an element
     * @param {cn_parking_space} element
     * @returns {Array<cn_element>}
     */
    _get_siblings(element) {
        return this._scene.parking_spaces;
    }

}

